import { useEffect, useState } from 'react';
import { loadingBillingChannelsMsg, t } from '../../../common/i18n/index.js';
import { useOpenFormAsync } from '../OpenFormProvider.js';
import type { BillChannel } from '../../../generated/api/billChannel.js';

export const useOpenFormBillChannels = () => {
  const [data, setData] = useState<BillChannel[]>([]);
  const async = useOpenFormAsync();

  useEffect(() => {
    const { controller } = async.fetch
      .getBillChannels()
      .resolved(setData)
      .rejected(text => async.actions.notification({ text, type: 'warning' }))
      .cache()
      .execute({ disable: true, message: t.F514(loadingBillingChannelsMsg) });

    return () => controller.abort();
  }, [async]);

  return data;
};
